import { applyMemberEvents, setChannelInfo, setUserInfoArr, upsertRecentChannelItem } from '../../../slice';
import { Store } from '../../../store';
import { getLocalUserDetails } from '../commonActions';
import logger from '../../../Helpers/logger';

export const handleChannelCreatedOrAdded = ({ data, event }) => {
    try {
        const settings = data?.settings || data.channel.settings;
        const isAdded = event === 'ADDED_TO_CHANNEL';
        const localUserId = getLocalUserDetails().userId;
        const members = data.participants.find(res => res.userId === localUserId);
        const restructured = {
            ...data.channel,
            ...(settings && { settings }),
            memberCount: data.participants?.length + isAdded ? 1 : 0,
            member: members,
            participants: data.participants.map(participant => ({
                ...participant,
                userId: participant.userId,
                roleId: participant.roleId ?? 3,
            })),
        };
        const memberEvents = restructured.participants.map(member => ({
            type: 'ADD',
            member,
        }));
        if (members.userId === getLocalUserDetails()?.userId) {
            Store.dispatch(setUserInfoArr(restructured.participants));
        }
        Store.dispatch(applyMemberEvents({ channelId: restructured?.channelId, memberEvents }));
        Store.dispatch(setChannelInfo(restructured));

        Store.dispatch(
            upsertRecentChannelItem({
                channelId: restructured.channelId,
                createChannelObj: restructured,
                lastActivityAt: restructured.lastActivityAt,
            }),
        );
    } catch (error) {
        logger.debug('failde to handle create or Added in channel', error);
    }
};
